export default __webpack_public_path__ + "static/media/chat-docs-image.66c8f902.svg";